export const HIGHSCHOOL_NOT_LISTED = 'School Not Listed';
